export { default } from './Microfrontend';
export * from './Microfrontend';
